<template>
    <div class="chart position--relative">
        <template v-if="loading">
            {{ $t('global.loadingData') }}
        </template>
        <template v-else>
            <div class="chart__content">
                <template v-if="!chart.hasNoData">
                    <!-- eslint-disable max-len -->
                    <apexchart
                        :class="graphClass"
                        :width="chart.chartOptions.chart.width"
                        :height="chart.chartOptions.chart.height"
                        :options="chart.chartOptions"
                        :series="chart.series"
                    />
                </template>
                <div v-else class="chart__no-results">
                    {{ $t('warning.cantShowDataForThisSearch') }}
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts';

export default {
    components: {
        apexchart: VueApexCharts
    },
    props: {
        chart: Object,
        loading: Boolean,
        graphClass: String
    }
};
</script>